/**
 * Chat Button Component
 * Floating button to open/close chat
 */

export class ChatButton {
  private container: HTMLElement;
  private button: HTMLButtonElement;
  private onClick: () => void;
  private position: 'right' | 'left';

  constructor(container: HTMLElement, onClick: () => void, position: 'right' | 'left' = 'right') {
    this.container = container;
    this.onClick = onClick;
    this.position = position;
    this.button = this.createButton();
  }

  private createButton(): HTMLButtonElement {
    const button = document.createElement('button');
    button.className = `chat-button ${this.position === 'left' ? 'position-left' : ''}`;
    button.innerHTML = '💬';
    button.setAttribute('aria-label', 'Open chat');
    button.addEventListener('click', this.onClick);
    this.container.appendChild(button);
    return button;
  }

  hide() {
    this.button.classList.add('hidden');
  }

  show() {
    this.button.classList.remove('hidden');
  }

  destroy() {
    this.button.remove();
  }
}
